import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  ChannelEpgParams,
  EpisodeDurationData,
  OverlayAction,
  OverlayMutation,
  OverlaySection,
  OverlayState
} from "@/components/overlay/types";
import { ChannelChangeGetter } from "@/components/channelChange/types";
import dayjs from "dayjs";
import apiService from "@/services/apiService/apiService";
import { Namespace } from "@/store/types";
import { formatEpgDates } from "@/helpers/utils";
import { EpgItem } from "@/services/apiService/api.types";

const updateOverlayStatus = (
  context: ActionContext<OverlayState, RootState>,
  overlayStatus: OverlaySection
): void => {
  if (!overlayStatus) {
    context.commit(OverlayMutation.ClearOverlayOpen);
    return;
  }
  context.commit(OverlayMutation.SetOverlayOpen, overlayStatus);
};

const updateChannelEpg = async (
  context: ActionContext<OverlayState, RootState>,
  channelEpgParams?: ChannelEpgParams
): Promise<void> => {
  //adjusting for timezone difference
  const offset = -(new Date().getTimezoneOffset() / 60);
  const dateLocal =
    channelEpgParams && channelEpgParams.date
      ? channelEpgParams.date
      : dayjs().format("YYYY-MM-DD");
  const channelIdLocal =
    channelEpgParams && channelEpgParams.channelId
      ? channelEpgParams.channelId
      : context.rootGetters[
          `${Namespace.ChannelChange}/${ChannelChangeGetter.GetChannelId}`
        ];
  let { items: activeEpgList } = await apiService.getChannelEpg(
    parseInt(channelIdLocal),
    dateLocal,
    offset
  );

  activeEpgList = formatEpgDates<EpgItem>(activeEpgList, offset);

  context.commit(OverlayMutation.SetChannelEpg, activeEpgList);
};

const updateActiveVodItemProgressDuration = (
  context: ActionContext<OverlayState, RootState>,
  playbackTimestamp: number
): void => {
  context.commit(
    OverlayMutation.SetActiveVodItemProgressDuration,
    playbackTimestamp
  );
};

const UpdateEpisodeDuration = (
  context: ActionContext<OverlayState, RootState>,
  episodeData: EpisodeDurationData
): void => {
  const tvShowMeta = context.state.tvShowMeta;

  if (tvShowMeta) {
    tvShowMeta.forEach((season) => {
      season.episodes.forEach((episode) => {
        if (episode.id === episodeData.episodeId) {
          episode.duration = episodeData.duration;
        }
      });
    });

    context.commit(OverlayMutation.SetTvShowMeta, tvShowMeta);
  }
};

export const actions: ActionTree<OverlayState, RootState> &
  Record<OverlayAction, Action<OverlayState, RootState>> = {
  [OverlayAction.UpdateOverlayStatus]: updateOverlayStatus,
  [OverlayAction.UpdateChannelEpg]: updateChannelEpg,
  [OverlayAction.UpdateActiveVodItemProgressDuration]:
    updateActiveVodItemProgressDuration,
  [OverlayAction.UpdateEpisodeDuration]: UpdateEpisodeDuration
};
